import { engineerGuide } from './engineerGuide';
import type { HelpGuide } from './types';

export const HELP_GUIDES: HelpGuide[] = [engineerGuide];

export function guideForUser(roles: string[] | undefined): HelpGuide {
  if (roles?.length) {
    const match = HELP_GUIDES.find((guide) =>
      guide.roles.some((role) => roles.includes(role)),
    );
    if (match) return match;
  }
  return HELP_GUIDES[0];
}
